import { StaticInterface } from '../../../helpers/static-interface';
import Lottie from 'lottie-web';
import { knowledgePageIllustration } from './knowledge-page-illustration';
import { insightListingPageIllustration } from './insight-listing-page-illustration';
import { projectListingPageIllustration } from './project-listing-page-illustration';

export interface ITpxListingHeroUtils {
    loadLottie(parentEl: HTMLElement, json: Object): void;
}

export interface IStaticListingHeroUtils {
    new(...args: any[]): ITpxListingHeroUtils;
    init(): void;
}

/**
 * ListingHero utilities
 * @class
 */
export default class TpxListingHeroUtils
    implements StaticInterface<IStaticListingHeroUtils, typeof TpxListingHeroUtils> {
    constructor(element: HTMLElement) {
        const pageType = element.dataset.pageType;
        let animationToUse;

        if (pageType === "knowledgePage") {
            animationToUse = knowledgePageIllustration;
        } else if (pageType === "insightListing") {
            animationToUse = insightListingPageIllustration;
        } else if (pageType === "projectListing") {
            animationToUse = projectListingPageIllustration;
        }

        if (animationToUse !== undefined) { this.loadLottie(element, animationToUse); }
    }

    /**
     * Load lottie animations
     */
    loadLottie(parentEl: HTMLElement, json: Object): void {
        const pageType = parentEl.dataset.pageType;
        const container = parentEl.querySelector('[data-component="listing-hero-animation"]');
        const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

        if (!prefersReducedMotion) {
            if (container !== null) {
                Lottie.loadAnimation({
                    animationData: json,
                    container,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                });
            }
        }
        else {
            if (pageType === "knowledgePage") {
                const animationFallback = parentEl.querySelector('[data-component="knowledgePage-animation-fallback"]');
                animationFallback.classList.remove("hide");
                container.classList.add("hide");
            } else if (pageType === "insightListing") {
                const animationFallback = parentEl.querySelector('[data-component="insightListing-animation-fallback"]');
                animationFallback.classList.remove("hide");
                container.classList.add("hide");
            }
        }
    }

    /**
     * Create new instances of TpxListingHero for each element with attribute data-component="listing-hero"
     */
    static init(scope?: HTMLElement) {
        [
            ...(scope || document).querySelectorAll('[data-component="listing-hero"]'),
        ].forEach((hero) => {
            new TpxListingHeroUtils(hero as HTMLElement);
        });
    }
}
